
(function loadingDirectiveDefinition() {

    'use strict';

    angular.module('Loading')
        .directive('crLoading', [
            'loading', function(loading) {
                return {
                    template: "<div class=\"loader\"></div>",
                    restrict: 'A',
                    replace: true,
                    link: function loadingDirectiveLink(scope, element) {
                        element.hide();

                        loading.registerLoader(element);

                        scope.$on('$destroy', function() {
                            loading.unRegisterLoader(element);
                        });
                    }
                };
            }
        ]);

})();